import * as stylex from "@stylexjs/stylex";
import { colors, fontSizes } from "@softmax/design-system/tokens.stylex";

export function PlayEmptyNote({ children }: { readonly children: string }) {
  return <p {...stylex.props(styles.empty)}>{children}</p>;
}

const styles = stylex.create({
  empty: {
    margin: 0,
    fontSize: fontSizes.small,
    fontStyle: "italic",
    lineHeight: "18px",
    color: colors.muted,
  },
});
